// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CopieurItem {
    font-family: 'Poppins', sans-serif;
    align-items: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    filter: drop-shadow(0px 6.37365px 23.5335px rgba(0, 0, 0, 0.15));
    ;
    width: 17.5rem;
    background-color: var(--fondCopieur);
    border-radius: 15px;
    padding: 4px;
    gap: 14px;
}

.separator {
    border: 1px solid black;
    opacity: 0.2;
    width: 95%;
    margin: 6px;
}

.copieurName {
    color: var(--ecriture);
    text-transform: uppercase;
    font-size: 1.4rem;
    font-weight: 800;
}


.historique {
    color: var(--noir);
    background-color: transparent;
    border: transparent;
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    font-weight: normal;
}

.historique:hover {
    color: var(--bleu);
    text-decoration: underline;
}

.copieurInformation {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.copieurInformation>button {
    color: var(--blanc);
    border-radius: 0.4rem;
    border-style: none;
    margin: 0.25rem;
    padding: 0.5rem;
    width: 10rem;

}

.copieurInformation>button:first-child {
    background-image: linear-gradient(90deg, #8554C5 50%, transparent 50%);
    background-size: 500px;
    background-repeat: no-repeat;
    background-position: 0%;
    transition: background 500ms ease-in-out;
}

.copieurInformation>button:hover {
    cursor: pointer;
    background-position: 100%;
    color: #8554C5;
}

.nbStat {
    display: flex;
    flex-direction: row;
}

.nbStatType {
    font-size: 14px;
}

.nbColonne {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-left: 1rem;
    padding-right: 1rem;
    color: var(--ecriture);
}

.nbColonne>h1 {
    font-size: 1.5rem;
}

.square {
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: var(--violet);
    padding: 0px 2px 0px 2px;
    margin: -0.5rem;
    margin-bottom: 0.5rem;
    width: 48px;
    height: 48px;
    line-height: 0.01rem;
    border-radius: 20%;
}

.squareDesactivated {
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: var(--gris);
    padding: 0px 2px 0px 2px;
    margin: -0.5rem;
    margin-bottom: 0.5rem;
    width: 48px;
    height: 48px;
    line-height: 0.01rem;
    border-radius: 20%;
}

.squareNumber {
    font-size: 24px;
}

.sizeSmallNumber {
    font-size: 2em;
}

.sizeBigNumber {
    font-size: 1.3em;
}

.timeZone {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
    padding: 12px 16px;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 10px;
    color: var(--ecriture);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    font-size: 0.9rem;
    margin: 0 auto;
    transition: all 0.3s ease;
    width: 90%;
}

.timeZone:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    background-color: #fff;
}

.timeItem {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #444;
}

.timeItem i {
    color: #777;
    font-size: 16px;
}


/* code de start.css migré dans copyItem.Css */
.historique {
    font-size: 7px;
    width: 50px;
}


.details {
    color: var(--noir);
    width: 50px;
    border: transparent;
    font-family: 'Poppins', sans-serif;
    font-size: 7px;
}

.details:hover {
    text-decoration: underline;
    color: var(--bleu);
    cursor: pointer;
}

.copieurActions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.collapseButton {
    background: #f0f0f0;
    padding: 6px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 100%;
}

.sessionBtn {
    display: block;
    width: 100%;
    padding: 10px 14px;
    margin: 6px 0;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 0.9rem;
    text-align: left;
    color: var(--ecriture);
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.sessionBtn:hover {
    background-color: #f0f0f0;
    transform: translateY(-1px);
}


/*.infoBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem ;
   
}*/`, "",{"version":3,"sources":["webpack://./src/components/CopieurItem/CopieurItem.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gEAAgE;;IAEhE,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,kCAAkC;IAClC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;;AAEhB;;AAEA;IAEI,sEAAsE;IACtE,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IAEvB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,+BAA+B;IAC/B,wBAAwB;IACxB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA,8CAA8C;AAC9C;IACI,cAAc;IACd,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;;AAGA;;;;;EAKE","sourcesContent":[".CopieurItem {\n    font-family: 'Poppins', sans-serif;\n    align-items: center;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    filter: drop-shadow(0px 6.37365px 23.5335px rgba(0, 0, 0, 0.15));\n    ;\n    width: 17.5rem;\n    background-color: var(--fondCopieur);\n    border-radius: 15px;\n    padding: 4px;\n    gap: 14px;\n}\n\n.separator {\n    border: 1px solid black;\n    opacity: 0.2;\n    width: 95%;\n    margin: 6px;\n}\n\n.copieurName {\n    color: var(--ecriture);\n    text-transform: uppercase;\n    font-size: 1.4rem;\n    font-weight: 800;\n}\n\n\n.historique {\n    color: var(--noir);\n    background-color: transparent;\n    border: transparent;\n    font-family: 'Poppins', sans-serif;\n    font-size: 1rem;\n    font-weight: normal;\n}\n\n.historique:hover {\n    color: var(--bleu);\n    text-decoration: underline;\n}\n\n.copieurInformation {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.copieurInformation>button {\n    color: var(--blanc);\n    border-radius: 0.4rem;\n    border-style: none;\n    margin: 0.25rem;\n    padding: 0.5rem;\n    width: 10rem;\n\n}\n\n.copieurInformation>button:first-child {\n    background-image: -webkit-linear-gradient(90deg, #8554C5 50%, transparent 50%);\n    background-image: linear-gradient(90deg, #8554C5 50%, transparent 50%);\n    background-size: 500px;\n    background-repeat: no-repeat;\n    background-position: 0%;\n    -webkit-transition: background 500ms ease-in-out;\n    transition: background 500ms ease-in-out;\n}\n\n.copieurInformation>button:hover {\n    cursor: pointer;\n    background-position: 100%;\n    color: #8554C5;\n}\n\n.nbStat {\n    display: flex;\n    flex-direction: row;\n}\n\n.nbStatType {\n    font-size: 14px;\n}\n\n.nbColonne {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: var(--ecriture);\n}\n\n.nbColonne>h1 {\n    font-size: 1.5rem;\n}\n\n.square {\n    color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: var(--violet);\n    padding: 0px 2px 0px 2px;\n    margin: -0.5rem;\n    margin-bottom: 0.5rem;\n    width: 48px;\n    height: 48px;\n    line-height: 0.01rem;\n    border-radius: 20%;\n}\n\n.squareDesactivated {\n    color: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background-color: var(--gris);\n    padding: 0px 2px 0px 2px;\n    margin: -0.5rem;\n    margin-bottom: 0.5rem;\n    width: 48px;\n    height: 48px;\n    line-height: 0.01rem;\n    border-radius: 20%;\n}\n\n.squareNumber {\n    font-size: 24px;\n}\n\n.sizeSmallNumber {\n    font-size: 2em;\n}\n\n.sizeBigNumber {\n    font-size: 1.3em;\n}\n\n.timeZone {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 10px;\n    padding: 12px 16px;\n    background: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    color: var(--ecriture);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    font-size: 0.9rem;\n    margin: 0 auto;\n    transition: all 0.3s ease;\n    width: 90%;\n}\n\n.timeZone:hover {\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);\n    background-color: #fff;\n}\n\n.timeItem {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #444;\n}\n\n.timeItem i {\n    color: #777;\n    font-size: 16px;\n}\n\n\n/* code de start.css migré dans copyItem.Css */\n.historique {\n    font-size: 7px;\n    width: 50px;\n}\n\n\n.details {\n    color: var(--noir);\n    width: 50px;\n    border: transparent;\n    font-family: 'Poppins', sans-serif;\n    font-size: 7px;\n}\n\n.details:hover {\n    text-decoration: underline;\n    color: var(--bleu);\n    cursor: pointer;\n}\n\n.copieurActions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.collapseButton {\n    background: #f0f0f0;\n    padding: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 100%;\n}\n\n.sessionBtn {\n    display: block;\n    width: 100%;\n    padding: 10px 14px;\n    margin: 6px 0;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    text-align: left;\n    color: var(--ecriture);\n    cursor: pointer;\n    transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.sessionBtn:hover {\n    background-color: #f0f0f0;\n    transform: translateY(-1px);\n}\n\n\n/*.infoBox {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 1rem ;\n   \n}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
